var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"rule-editor-container"}},[_c('iframe',{ref:"iframeRef",attrs:{"id":_vm.iframeId,"src":_vm.ruleEditorURL,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }